import Honeybadger from '@honeybadger-io/js';

import { requestApi } from 'api/Api';

import { errorMessageGuard } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

export const updateAdminPractice = async (navigate, params) => {
  return requestApi({
    navigate,
    params,
    url: '/api/practice/update'
  });
};

export const impersonate = async (navigate, params) => {
  await requestApi({
    navigate,
    params,
    url: '/api/admin/practice/impersonate',
    onError: (_, response) => {
      const { redirect, error } = response;
      Honeybadger.notify(
        `file: practitioners/PractitionersBasicInfo, method: impersonateUser - try, error: ${
          error ?? "There's been an error"
        }`
      );
      if (error) showAlert({ title: errorMessageGuard(error), color: 'danger' });
      navigate(redirect);
    },
    onSuccess: (_, response) => {
      const { redirect } = response;
      window.open(redirect, '_blank');
    }
  });
};
